export const relationGroupsConstants = {

    // REQUEST RELATION GROUPS TABLE DATA
    REQUEST_RELATION_GROUPS: 'REQUEST_RELATION_GROUPS',
    RECEIVE_RELATION_GROUPS: 'RECEIVE_RELATION_GROUPS',
    RELATION_GROUPS_ERROR: 'RELATION_GROUPS_ERROR',

    // ADD RELATION GROUP
    REQUEST_ADD_RELATION_GROUP: 'REQUEST_ADD_RELATION_GROUP',
    RECEIVE_ADD_RELATION_GROUP: 'RECEIVE_ADD_RELATION_GROUP',
    ADD_RELATION_GROUP_ERROR: 'ADD_RELATION_GROUP_ERROR',

    // EDIT RELATION GROUP
    REQUEST_EDIT_RELATION_GROUP: 'REQUEST_EDIT_RELATION_GROUP',
    RECEIVE_EDIT_RELATION_GROUP: 'RECEIVE_EDIT_RELATION_GROUP',
    EDIT_RELATION_GROUP_ERROR: 'EDIT_RELATION_GROUP_ERROR',

    // EDIT RELATION
    REQUEST_EDIT_RELATION: 'REQUEST_EDIT_RELATION',
    RECEIVE_EDIT_RELATION: 'RECEIVE_EDIT_RELATION',
    EDIT_RELATION_ERROR: 'EDIT_RELATION_ERROR',

    // DELETE RELATION
    REQUEST_DELETE_RELATION: 'REQUEST_DELETE_RELATION',
    RECEIVE_DELETE_RELATION: 'RECEIVE_DELETE_RELATION',
    DELETE_RELATION_ERROR: 'DELETE_RELATION_ERROR',

    // REQUEST_USER_RELATION_GROUP
    REQUEST_USER_RELATION_GROUP:'REQUEST_USER_RELATION_GROUP',
    RECEIVE_USER_RELATION_GROUP:'RECEIVE_USER_RELATION_GROUP',
    USER_RELATION_GROUP_ERROR:'USER_RELATION_GROUP_ERROR',
};



// WEBPACK FOOTER //
// ./src/_constants/relationGroups.constants.js